var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "validation-observer",
    {
      ref: "form",
      class: { "signature-readonly": _vm.isReadOnly },
      attrs: { novalidate: "" }
    },
    [
      _c("div", { staticClass: "signature-disclaimer" }, [
        _c("p", [
          _vm._v(
            " Este informe ha sido preparado por la Unidad de Evaluación Vocacional del Departamento de Educación de Puerto Rico. Su propósito es aportar información relevante para apoyar el proceso de transición del estudiante desde la etapa escolar hacia la vida adulta. Los resultados obtenidos no constituyen ni sustituyen un diagnóstico clínico, psicológico, médico o psiquiátrico, y se utilizan exclusivamente para apoyar la toma de decisiones educativas, la planificación de apoyos y la definición de metas académicas y laborales, conforme a los criterios éticos y técnicos aplicables. "
          )
        ]),
        _c("p", [
          _vm._v(
            " Los resultados aquí consignados no deben interpretarse como valores absolutos, sino como indicadores que orientan la planificación educativa y vocacional en el momento. Las recomendaciones incluidas se fundamentan en el análisis de la información recopilada durante el proceso de evaluación, y deben considerarse como parte de un esfuerzo continuo y flexible que puede enriquecerse con futuros procesos evaluativos. "
          )
        ]),
        _c("p", [
          _vm._v(
            " Este informe constituye un componente importante dentro del proceso de planificación educativa individualizada del estudiante con el fin de que los servicios de transición sean pertinentes y se alineen con las metas educativas, ocupacionales y de vida independiente del estudiante. La información contenida debe ser considerada por el Comité de Padres y Maestros (COMPU) como parte del proceso de revisión del Programa Educativo Individualizado (PEI) o del Programa de Servicios Educativos correspondiente. "
          )
        ]),
        _c("p", [
          _vm._v(
            " También se sugiere que el COMPU evalúe la ubicación educativa más adecuada para el estudiante, considerando la disponibilidad de recursos instructivos y personal capacitado que pueda atender sus necesidades de manera integral. "
          )
        ])
      ]),
      _c("validation-provider", {
        attrs: { name: "acceptedTermsResponsibilities", rules: "required" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({ errors }) {
              return [
                _c("custom-checkbox-single-option", {
                  staticClass: "custom-single-option signature-terms__checkbox",
                  attrs: {
                    "custom-error-msg":
                      "Debe aceptar los términos y responsabilidades para continuar.",
                    disabled: _vm.isReadOnly,
                    error: errors[0],
                    "option-text": "Acepto los términos y responsabilidades"
                  },
                  model: {
                    value: _vm.model.acceptedTermsResponsibilities,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "acceptedTermsResponsibilities", $$v)
                    },
                    expression: "model.acceptedTermsResponsibilities"
                  }
                })
              ]
            }
          }
        ])
      }),
      _c("hr", { staticClass: "my-4" }),
      _c("sign-plan", {
        ref: "signPlanRef",
        staticClass: "my-4",
        attrs: {
          disabled: _vm.isReadOnly,
          "is-electronic-signature": _vm.isElectronicSignature,
          "question-label":
            "¿Cuál será el mecanismo que se estará utilizando para firmar el Informe de Evaluación Vocacional?"
        },
        on: {
          "update:isElectronicSignature": function($event) {
            _vm.isElectronicSignature = $event
          },
          "update:is-electronic-signature": function($event) {
            _vm.isElectronicSignature = $event
          }
        }
      }),
      _vm.isElectronic
        ? _c(
            "div",
            { staticClass: "signature-flow mt-3" },
            [
              _c("section-title", {
                attrs: {
                  content: "Configuración de Firma Digital",
                  "has-line": ""
                }
              }),
              _c(
                "div",
                { staticClass: "signature-flow__panel text-center" },
                [
                  _c("signature-hub-info", {
                    staticClass: "signature-hub-info--embedded",
                    attrs: { "signature-info": _vm.signatureHubInfo },
                    on: { "configure-sign": _vm.handleConfigureSignatures }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isManual
        ? _c(
            "div",
            { staticClass: "signature-flow mt-3" },
            [
              !_vm.manualSignerAdded && !_vm.isReadOnly
                ? [
                    _c(
                      "validation-observer",
                      { ref: "manualForm", attrs: { slim: "" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "signature-manual row align-items-start"
                          },
                          [
                            _c("validation-provider", {
                              staticClass: "col-12 col-md-3",
                              attrs: { rules: _vm.nameRules },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c(
                                          "label",
                                          { staticClass: "data-label" },
                                          [_vm._v("Nombre del Evaluador:")]
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.model.evaluatorName,
                                              expression: "model.evaluatorName"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: { "is-invalid": errors[0] },
                                          attrs: {
                                            disabled: _vm.isReadOnly,
                                            maxlength: "50"
                                          },
                                          domProps: {
                                            value: _vm.model.evaluatorName
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.model,
                                                "evaluatorName",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        errors[0]
                                          ? _c("error", {
                                              attrs: {
                                                message: _vm.nameError,
                                                variant: "no-border"
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2760924250
                              )
                            }),
                            _c("validation-provider", {
                              staticClass: "col-12 col-md-1",
                              attrs: { rules: _vm.initialRules },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c(
                                          "label",
                                          { staticClass: "data-label" },
                                          [_vm._v("Inicial:")]
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.model.evaluatorInitialName,
                                              expression:
                                                "model.evaluatorInitialName"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: { "is-invalid": errors[0] },
                                          attrs: {
                                            disabled: _vm.isReadOnly,
                                            maxlength: "1"
                                          },
                                          domProps: {
                                            value:
                                              _vm.model.evaluatorInitialName
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.model,
                                                "evaluatorInitialName",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        errors[0]
                                          ? _c("error", {
                                              attrs: {
                                                message:
                                                  "Debe contener solo una letra.",
                                                variant: "no-border"
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2999468886
                              )
                            }),
                            _c("validation-provider", {
                              staticClass: "col-12 col-md-3",
                              attrs: { rules: _vm.nameRules },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c(
                                          "label",
                                          { staticClass: "data-label" },
                                          [_vm._v("Apellido Paterno:")]
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.model.evaluatorLastName,
                                              expression:
                                                "model.evaluatorLastName"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: { "is-invalid": errors[0] },
                                          attrs: {
                                            disabled: _vm.isReadOnly,
                                            maxlength: "50"
                                          },
                                          domProps: {
                                            value: _vm.model.evaluatorLastName
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.model,
                                                "evaluatorLastName",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        errors[0]
                                          ? _c("error", {
                                              attrs: {
                                                message: _vm.nameError,
                                                variant: "no-border"
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2860500888
                              )
                            }),
                            _c("validation-provider", {
                              staticClass: "col-12 col-md-3",
                              attrs: { rules: _vm.optionalNameRules },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c(
                                          "label",
                                          { staticClass: "data-label" },
                                          [_vm._v("Apellido Materno:")]
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.model
                                                  .evaluatorSecondLastName,
                                              expression:
                                                "model.evaluatorSecondLastName"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: { "is-invalid": errors[0] },
                                          attrs: {
                                            disabled: _vm.isReadOnly,
                                            maxlength: "50"
                                          },
                                          domProps: {
                                            value:
                                              _vm.model.evaluatorSecondLastName
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.model,
                                                "evaluatorSecondLastName",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        errors[0]
                                          ? _c("error", {
                                              attrs: {
                                                message: _vm.nameError,
                                                variant: "no-border"
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3790849829
                              )
                            }),
                            _c("validation-provider", {
                              staticClass: "col-12 col-md-2",
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-date-picker", {
                                          attrs: {
                                            id: "evaluatorDate",
                                            "class-container": "w-100",
                                            "custom-error-msg":
                                              "El campo es requerido.",
                                            disabled: _vm.isReadOnly,
                                            error: errors[0],
                                            format: "dd/MM/yyyy",
                                            label: "Fecha:",
                                            placeholder: "DD/MM/YYYY"
                                          },
                                          model: {
                                            value: _vm.model.evaluatorDate,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "evaluatorDate",
                                                $$v
                                              )
                                            },
                                            expression: "model.evaluatorDate"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3524216523
                              )
                            }),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 col-md-auto signature-manual__action"
                              },
                              [
                                _c("action-button", {
                                  attrs: {
                                    disabled:
                                      !_vm.canAddManualSigner || _vm.isReadOnly,
                                    i: "fas fa-file-medical",
                                    text: "Añadir",
                                    variant: "success"
                                  },
                                  on: { click: _vm.addManualSigner }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ]
                : _vm._e(),
              _vm.manualSignerAdded
                ? _c("div", { staticClass: "signature-manual-summary row" }, [
                    _c("div", { staticClass: "col-12 col-md" }, [
                      _c("span", { staticClass: "signature-flow__label" }, [
                        _vm._v("Nombre del Evaluador:")
                      ]),
                      _c("strong", [_vm._v(_vm._s(_vm.model.evaluatorName))])
                    ]),
                    _c("div", { staticClass: "col-12 col-md-1" }, [
                      _c("span", { staticClass: "signature-flow__label" }, [
                        _vm._v("Inicial:")
                      ]),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm._f("empty")(_vm.model.evaluatorInitialName)
                          )
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "col-12 col-md" }, [
                      _c("span", { staticClass: "signature-flow__label" }, [
                        _vm._v("Apellido Paterno:")
                      ]),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.model.evaluatorLastName))
                      ])
                    ]),
                    _c("div", { staticClass: "col-12 col-md" }, [
                      _c("span", { staticClass: "signature-flow__label" }, [
                        _vm._v("Apellido Materno:")
                      ]),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm._f("empty")(_vm.model.evaluatorSecondLastName)
                          )
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "col-12 col-md" }, [
                      _c("span", { staticClass: "signature-flow__label" }, [
                        _vm._v("Fecha:")
                      ]),
                      _c("strong", [
                        _vm._v(_vm._s(_vm._f("date")(_vm.model.evaluatorDate)))
                      ])
                    ]),
                    !_vm.isReadOnly
                      ? _c(
                          "button",
                          {
                            staticClass: "signature-manual-summary__remove",
                            attrs: { type: "button" },
                            on: { click: _vm.resetManualSignature }
                          },
                          [_c("i", { staticClass: "fas fa-times-circle" })]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm.manualSignerAdded
                ? [
                    _c("section-title", {
                      staticClass: "mt-3",
                      attrs: { "has-line": "", title: "Documento" }
                    }),
                    !_vm.hasDownloadedTemplate
                      ? _c(
                          "div",
                          { staticClass: "signature-flow__panel text-center" },
                          [
                            _c("action-button", {
                              attrs: {
                                i: "fas fa-file-download",
                                text:
                                  "Descargar Informe de Evaluación Vocacional",
                                variant: "outline-success"
                              },
                              on: { click: _vm.downloadTemplate }
                            })
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "signature-document-row row" },
                          [
                            _c("div", { staticClass: "col-md-4" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-gray-6 font-14 font-weight-normal"
                                },
                                [_vm._v(" Documento: ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-16 font-weight-normal"
                                },
                                [_vm._v(" Informe de Evaluación Vocacional ")]
                              )
                            ]),
                            _c(
                              "div",
                              { staticClass: "col-md-5" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "color-gray-6 font-14 font-weight-normal"
                                  },
                                  [_vm._v(" Archivo: ")]
                                ),
                                _vm.hasSignedDocument && !_vm.editingDocument
                                  ? _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("empty")(
                                              _vm.model.signedDocumentName
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  : _c("validation-provider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("custom-file-input", {
                                                  attrs: {
                                                    accept:
                                                      _vm.acceptedDocumentTypes,
                                                    "attachment-id":
                                                      _vm.model
                                                        .signedDocumentId,
                                                    "custom-error-msg":
                                                      "Favor de anejar el documento firmado.",
                                                    disabled: _vm.isReadOnly,
                                                    "display-style": "normal",
                                                    error: errors[0],
                                                    "label-position": "left",
                                                    required: ""
                                                  },
                                                  on: {
                                                    input:
                                                      _vm.saveSignedDocumentFile
                                                  },
                                                  model: {
                                                    value: _vm.selectedDocument,
                                                    callback: function($$v) {
                                                      _vm.selectedDocument = $$v
                                                    },
                                                    expression:
                                                      "selectedDocument"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        3995703056
                                      )
                                    })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-3 d-flex justify-content-end"
                              },
                              [
                                _vm.hasSignedDocument && !_vm.editingDocument
                                  ? _c(
                                      "div",
                                      [
                                        !_vm.isReadOnly
                                          ? _c("action-button", {
                                              staticClass: "mr-2 mt-1",
                                              attrs: {
                                                i:
                                                  "fas fa-times text-danger mr-n1 pr-1",
                                                variant: "outline-danger"
                                              },
                                              on: {
                                                click: _vm.resetSignedDocument
                                              }
                                            })
                                          : _vm._e(),
                                        _c("action-button", {
                                          staticClass: "mt-1",
                                          attrs: {
                                            i:
                                              "fas fa-file-download text-white mr-n1 pr-1",
                                            variant: "success"
                                          },
                                          on: {
                                            click: _vm.downloadSignedDocument
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }